import { render, staticRenderFns } from "./ActionsTabContent.vue?vue&type=template&id=566a6cce&scoped=true&"
import script from "./ActionsTabContent.vue?vue&type=script&lang=js&"
export * from "./ActionsTabContent.vue?vue&type=script&lang=js&"
import style0 from "./ActionsTabContent.vue?vue&type=style&index=0&id=566a6cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a6cce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
